// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__11PAb","header":"MessagesList_header__3y-0q","chat":"MessagesList_chat__1xTcv"};